import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    standalone: false
})

export class FooterComponent implements OnInit {
  currentYear: number;

  @Input() lastLogonDate: string;

  constructor() {
    this.currentYear = new Date().getFullYear();
  }

  ngOnInit() {
  }
}
